import api from "./api";
import { getBackendUrl } from "../config";

export const listQuizzes = async () => {
  const { data } = await api.get("/quizzes");
  return data;
};

export const showQuiz = async (id) => {
  const { data } = await api.get(`/quizzes/${id}`);
  return data;
};

export const createQuiz = async (quiz) => {
  const { data } = await api.post("/quizzes", quiz);
  return data;
};

export const updateQuiz = async (id, quiz) => {
  const { data } = await api.put(`/quizzes/${id}`, quiz);
  return data;
};

export const deleteQuiz = async (id) => {
  await api.delete(`/quizzes/${id}`);
};

export const saveSteps = async (quizId, steps) => {
  const { data } = await api.put(`/quizzes/${quizId}/steps`, { steps });
  return data;
};

export const getResponses = async (quizId) => {
  const { data } = await api.get(`/quizzes/${quizId}/responses`);
  return data;
};

export const exportQuiz = async (id) => {
  const { data } = await api.get(`/quizzes/${id}/export`);
  return data;
};

export const importQuiz = async (quizJson) => {
  const { data } = await api.post("/quizzes/import", quizJson);
  return data;
};

export const uploadQuizImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post("/quizzes/upload-image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  // O backend retorna caminho relativo (/public/...) — precisa do host do backend
  const url = data.url;
  if (!url) return "";
  return url.startsWith("http") ? url : `${getBackendUrl()}${url}`;
};
